import { Error403, Paragraph, Spin } from 'components/common'
import React from 'react'
import { selectOrganizationName } from 'lib/redux/auth'
import { useAppSelector } from 'lib/redux'
import { PageProps } from 'gatsby'
import { useState } from 'react'
import moment from 'moment'
import { Info, Title } from 'components/common'
import { DayStatusCard } from 'components/bookings'
import DailyTable from 'pages/admin/home/daily-table'
import MonthlyTable from 'pages/admin/home/monthly-table'

const Calendar = (page: PageProps<Queries.Query>) => {
  const organizationName = useAppSelector(selectOrganizationName)
  const [viewDay, setViewDay] = useState<moment.Moment>(moment())
  const [dailyViewTable, setViewDailyTable] = useState(false)

  const handleDailyView = (date: moment.Moment) => {
    if (date) {
      setViewDay(date)
    }
  }

  if (organizationName === 'saga-observer') {
    return (
      <>
        {/* サイドバーをつけるときはこんな感じで実装したら良いと思います。 */}
        {/*ex) <div className='flex'>
               <CalendarSideBar/> ←新規実装
               <Button>更新</Button>
               <BookingsCalendar/>
             </div> */}
        <div className=" mx-auto my-o max-w-screen-lg">
          <Info title="チェックマークは予約があることを表し、チェックマークがない場合は予約がないことを表します。">
            <Title>予約状況</Title>
          </Info>
          <DayStatusCard
            onChangeToDaily={setViewDailyTable}
            dailyView={dailyViewTable}
            viewDay={viewDay}
            handleDailyView={handleDailyView}
          >
            {dailyViewTable ? (
              <DailyTable currentDate={viewDay} page={page} isObserver={true} />
            ) : (
              <MonthlyTable
                currentDate={viewDay}
                handleDailyView={handleDailyView}
                onChangeToDaily={setViewDailyTable}
                page={page}
              />
            )}
          </DayStatusCard>
        </div>
      </>
    )
  } else {
    const errorMessage = (
      <>
        <Paragraph>この組織にはログイン権限が有りません。</Paragraph>
        <Paragraph>
          組織およびメールアドレス、パスワードを確認のうえ、再度ログインしてください。
        </Paragraph>
      </>
    )
    return <Error403 message={errorMessage} />
  }
}

export default Calendar
